import { render, staticRenderFns } from "./BaseSwitcher.vue?vue&type=template&id=e4a676f6&scoped=true"
import script from "./BaseSwitcher.vue?vue&type=script&lang=js"
export * from "./BaseSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BaseSwitcher.vue?vue&type=style&index=0&id=e4a676f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a676f6",
  null
  
)

export default component.exports